module.exports = __webpack_public_path__ + "img/symbols.23c2827c.svg";